export default {
  JSON: 'json',
  BLOB: 'blob',
  ARRAY_BUFFER: 'arrayBuffer',
  TEXT: 'text'
}



// WEBPACK FOOTER //
// ./src/scripts/consts/RestResultType.js